
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gangwon-crematorium-place/region/[sido]/[sigungu]",
      function () {
        return require("private-next-pages/gangwon-crematorium-place/region/[sido]/[sigungu]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gangwon-crematorium-place/region/[sido]/[sigungu]"])
      });
    }
  